$(() => {
  if ($('.task__content .hazard').length) {
    HandshqApp.generateHazardsCollection();
  }
});
